module.exports = __webpack_public_path__ + "static/media/Fenocat.2b631c42.png";